<template>
  <div
    class="Recover"
    @click="$emit('close')"
  >
    <div
      class="login-box"
      @click.stop
    >
      <img src="@/assets/images/logo.svg">
      <form
        @keyup.enter="send"
      >
        <BaseInput
          v-model="email"
          type="text"
          name="form-username"
          :placeholder="$t('AUTHORFORM.EMAILPLACEHOLDER')"
          required
        >
          <template #error>
            <ValidationError
              :errors="errors"
              name="form-username"
            />
          </template>
        </BaseInput>
      </form>
      <BaseButton
        @click="send"
      >
        {{ $t('BUTTON.SEND') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import ValidationMixin from '@/mixins/ValidationMixin.js';
import ValidationError from '@/components/ValidationError.vue';

export default {

  components: {
    ValidationError,
  },

  mixins: [ValidationMixin],

  data: () => ({
    email: '',
    error: false,
  }),

  methods: {
    send() {
      try {
        if (this.areErrors()) {
          throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
        } else {
          const payload = {
            email: this.email,
          };
          this.$store.dispatch('authModule/passwordRecover', payload);
          this.$emit('close');
          this.$toast.success('Email sent');
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.Recover {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .login-box {
    padding: 2rem 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 450px;
    text-align: center;
    img{
      width: 250px;
      margin-bottom: 1rem;
    }
    .BaseInput {
      ::v-deep {
        input {
          border-radius: 10px;
          border: solid 2px var(--color-primary);
          //border-bottom: solid 1px white;
          color: rgb(37, 35, 35);
          text-align: center;
          border-radius: 10px;
          width: 100%;
          padding-top: 6px;
          margin-bottom: 1rem;
        }
      }
    }
    .recover{
      color:white;
      text-align: left;
      margin-top: -15px;

    }
    .BaseButton {
      margin-top: 15px;
      text-align: center;

    }
  }
}
</style>
